import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from './index';

const DeleteModal = ({ isOpen, onCloseModal, toggleConfirm, primaryButtonDisabled }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onConfirm={toggleConfirm}
      onClose={onCloseModal}
      title={t('deleteModal.prompt')}
      description={t('deleteModal.description')}
      primaryButtonDisabled={primaryButtonDisabled}
    />
  );
};

export default DeleteModal;
